/**
 * MODELO DE NEGOCIO Y DÍA HÁBIL (1.6b, MOD-01; FEC-02/03).
 *
 * Todo comercio tiene un modelo y decide cómo se liquida: COMPRA_DEUDA (CrediTotal le paga lo
 * financiado según el plazo) o COBRANZA (le paga lo cobrado). Vive en cada versión de las
 * condiciones (`business_model`). Sin modelo no se liquida.
 * El contrato dice qué pasa si la fecha de pago cae en fin de semana o feriado; sin regla escrita
 * rige NEXT_BUSINESS_DAY, como en el núcleo (dominio/fechas.js).
 * Un solo lugar para los textos: la ficha y las condiciones dicen lo mismo.
 */
const MODELOS: Record<string, string> = {
  COMPRA_DEUDA: 'Compra de deuda',
  COBRANZA: 'Cobranza',
};

const DIA_HABIL: Record<string, string> = {
  NEXT_BUSINESS_DAY: 'Paga el hábil siguiente',
  SAME_DAY: 'Paga el mismo día',
};

/** El nombre del modelo, o '' si la versión no tiene (la pantalla avisa). */
export const modeloNegocio = (v: any): string => MODELOS[v?.business_model] || '';

/** Qué pasa con un pago que cae en día no hábil. */
export const diaHabil = (v: any): string => {
  if (!v) return '—';
  const regla = v.settlement?.business_day_rule || 'NEXT_BUSINESS_DAY';
  return DIA_HABIL[regla] || regla;
};
